import React from "react";
import styles from "./index.module.scss";
import { formatCurrency } from "../../../../utils/utils";
import { PRETypes } from "..";
import moment from "moment";

interface AddressModalProps {
  isScrolled?: boolean;
  preData: PRETypes[];
}

export default function AddressModal({
  isScrolled,
  preData
}: AddressModalProps) {
  return (
    <div
      className={`${styles.AddressSection} ${
        isScrolled ? styles.scrolled : ""
      }`}
    >
      <div className={styles.header}>
        <div className={styles.title}>Address</div>
        <div className={styles.title}>Purchased Date</div>
        <div className={styles.title}>Lender</div>
      </div>
      {preData === null || preData?.length === 0 ? (
        <div className={styles.noData}>No PRE found</div>
      ) : (
        <>
          {preData?.map((item: PRETypes, index: number) => (
            <div key={index} className={styles.content}>
              <div className={styles.contentLeft}>
                <div
                  className={`${styles.statusTag} ${
                    !item?.isFlipper ? styles.pre : ""
                  }`}
                >
                  {item?.isFlipper ? "FLIP" : "PRE"}
                </div>
                <div className={styles.text}>
                  {item.situsFullAddress}, {item.situsCity}, {item.situsState}{" "}
                  {item.situsZIP5}
                </div>
                {/* <div className={styles.text}>
                  
                </div> */}
                <div className={styles.Price}>
                  {item?.currentSalesPrice
                    ? formatCurrency(+item?.currentSalesPrice, "USD", "en-US")
                    : "N/A"}
                </div>
              </div>
              <div className={styles.date}>
                {item?.currentSaleRecordingDate
                  ? moment(item?.currentSaleRecordingDate, "YYYYMMDD").format(
                      "MM/DD/YYYY"
                    )
                  : "N/A"}
              </div>
              <div className={styles.Lender}>
                {item.concurrentMtg1Lender ? item.concurrentMtg1Lender : "N/A"}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
